import http from "./http.js";

async function getProduct(id) {
  try {
    const response = await http.get(`products/${id}`);
    return {
      title: response.data.title,
      article: response.data.article,
      amount: response.data.amount,
      comments: response.data.comments,
      description: response.data.description,
      actualVersion: response.data.actualVersion,
      purchaseCost: response.data.purchaseCost,
      productVersions: response.data.productVersions
        ? response.data.productVersions.map(p => {
          return {
            version: p.version,
            notes: p.notes,
            releaseDate: p.releaseDate,
            id: p.id,
          };
        })
        : null,
      category: {
        id: response.data.category.id,
        title: response.data.category.title,
      },
      type: response.data.type,
      trackVersions: response.data.trackVersions,
      id: response.data.id,
    };
  } catch (err) {
    throw err;
  }
}

async function getProductInstallations(id) {
  try {
    const response = await http.get(`products/${id}/installed`);

    class ProductClient{
      constructor(productClient) {
        this.analyst = productClient.analyst;
        this.client = productClient.client;
        this.partnershipStopped = productClient.partnershipStopped;
        this.jiraIssueKey = productClient.jiraIssueKey;
        this.lastServicePaidTo = productClient.lastServicePaidTo;
        this.manager = productClient.manager;
        this.notes = productClient.notes;
        this.upToDate = productClient.upToDate;
        this.updateByClient = productClient.updateByClient;
        this.version = productClient.version;
      }
      isOverdue(){
        return new Date(this.lastServicePaidTo) > new Date() || !this.lastServicePaidTo;
      }
    }

    return response.data.map(c => new ProductClient({
      client: {
        id: c.client.id,
        title: c.client.title,
      },
      partnershipStopped: c.partnershipStopped,
      manager: c?.manager || null,
      analyst: c?.analyst || null,
      jiraIssueKey: c.jiraIssueKey === "null" ? null : c.jiraIssueKey,
      updateByClient: c.updateByClient,
      upToDate: c.upToDate,
      version: c.version,
      notes: c.notes,
      lastServicePaidTo: c?.lastServicePaidTo || null,
    }));
  } catch (err) {
    throw err;
  }
}

async function updateProduct(id, product) {
  try {
    const response = await http.put(`products/${id}`, product);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createProduct(product) {
  try {
    const response = await http.post("products", product);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getProducts(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `products?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function assignJiraIssue(clientId, productId, jiraIssueKey) {
  try {
    const response = await http.patch(
      `clients/${clientId}/software/${productId}/jira-issue-key`, jiraIssueKey
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function createProductVersion(productId, productVersion) {
  try {
    await http.post(`products/${productId}/versions`, productVersion);
  } catch (err) {
    throw err;
  }
}

async function deleteProductVersion(productVersionId) {
  try {
    await http.delete(`products/versions/${productVersionId}`);
  } catch (err) {
    throw err;
  }
}

async function selectProduct(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "products/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      });
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function validateArticle(article, productId = null) {
  try {
    const response = await http.get(`/products/articles/${article}/uniq`, {
      params: {
        productId,
      },
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getProduct,
  getProductInstallations,
  updateProduct,
  createProduct,
  selectProduct,
  getProducts,
  assignJiraIssue,
  createProductVersion,
  deleteProductVersion,
  validateArticle,
};
